import { useState, useEffect, useRef } from 'react';

interface LazyProfileImageProps {
  src?: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
}

export function LazyProfileImage({ src, alt, className = '', style }: LazyProfileImageProps) {
  const [imageSrc, setImageSrc] = useState<string | undefined>(undefined);
  const [isVisible, setIsVisible] = useState(false);
  const imgRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    if (!imgRef.current || !src) return;
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '100px' } // Start loading 100px before entering viewport
    );
    
    observer.observe(imgRef.current);
    
    return () => observer.disconnect();
  }, [src]);
  
  useEffect(() => {
    if (isVisible && src) {
      setImageSrc(src);
    }
  }, [isVisible, src]);
  
  // Render as background image div to match existing usage
  return (
    <div
      ref={imgRef}
      className={className}
      style={{
        ...style,
        backgroundImage: imageSrc ? `url('${imageSrc}')` : undefined,
      }}
    />
  );
}

